import { bindCartBtnRemove } from "@olmokit/core/cart";
import "./Remove.scss";

/**
 * Component: CartRemove
 */
export function CartRemove() {
  console.log("CartRemove mounted.");
  bindCartBtnRemove();
}
